<template>
  <div class="validate" :class="{ center: questions.length === 0 }">
    <div class="content-poll-wrap">
      <div class="content">
        <p>{{ newTexts }}</p>
        <p v-if="shouldResendEmail">{{ $t("validate.didntrecieve") }}</p>
        <a v-if="shouldResendEmail" @click="resendEmail">{{
          $t("validate.resend")
        }}</a>
        <div
          class="item"
          v-for="(question, i) in questions"
          :key="question.pqt_id"
        >
          <span v-html="question.text" class="question-title"></span>
          <v-select
            class="custom-dropdown"
            :class="{ hack: question.pqt_id === 34 }"
            v-if="question.type === 'select'"
            v-model="answers[question.pqt_id]"
            :options="handleAnswers(question.answers)"
            @input="handleSelectAnswer"
          ></v-select>
          <div
            v-else-if="question.type === 'checkbox'"
            v-for="checkbox in question.answers"
            class="checkbox-wrap"
            :key="checkbox.pqt_id"
          >
            <input
              class="fixed-width"
              type="checkbox"
              :id="'validate-checkbox-' + checkbox.pqa_id"
              @change="
                handleCheckbox(
                  $event.target.checked,
                  question.pqt_id,
                  checkbox.pqa_id
                )
              "
            />
            <label :for="'validate-checkbox-' + checkbox.pqa_id">
              {{ checkbox.text }}
            </label>
          </div>
          <div v-else-if="question.type === 'badge'" class="badge-list">
            <div
              class="badge-wrap"
              v-for="checkbox in question.answers"
              :key="checkbox.pqa_id"
            >
              <Badge
                v-if="resetList"
                :text="checkbox.text"
                :selected="answers[question.pqt_id][checkbox.pqa_id]"
                @select="handleBadge($event, question.pqt_id, checkbox.pqa_id)"
              />
            </div>
          </div>
          <div v-else-if="question.type === 'radio'" class="radio-wrap">
            <div
              v-for="(ans, i) in question.answers"
              :key="i"
              class="radio-inner-wrap"
            >
              <input
                @change="updateRadio(question, ans)"
                type="radio"
                name="radio-question"
                :id="`ans${ans.pqa_id}`"
                :value="ans.pqa_id"
              />
              <label :for="`ans${ans.pqa_id}`">{{ ans.text }}</label>
            </div>
          </div>
          <input
            v-else
            class="base-input"
            v-model="answers[question.pqt_id]"
            :type="question.type"
          />
          <hr v-if="i !== questions.length - 1" />
        </div>
        <div class="button-wrap">
          <div
            class="button-round"
            :class="{ 'is-last': isLast }"
            @click="handleNext"
            v-if="button"
          >
            {{ !isLast ? $t("button.next") : $t("button.submit") }}
            <span class="material-icons">
              {{ !isLast ? "navigate_next" : "done" }}
            </span>
          </div>
        </div>
      </div>
      <PollProgress v-if="progress" :data="progress" />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import vSelect from "vue-select";
import Badge from "../Badge";
import PollProgress from "./PollProgress.vue";
import { mapState } from "vuex";

export default {
  components: {
    vSelect,
    Badge,
    PollProgress,
  },
  props: {
    // title: String,
    isLast: Boolean,
    texts: String,
    currentEmail: String,
    date: String,
    questions: {
      type: Array,
      required: false,
      default: () => [],
    },
    button: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    shouldResendEmail: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      answers: {},
      resetList: true,
      newTexts: "",
    };
  },
  watch: {
    questions: {
      deep: true,
      handler() {
        this.init();
      },
    },
    texts: {
      deep: true,
      handler() {
        if (this.texts)
          this.newTexts = this.texts.replace(
            "{{email}}",
            this.currentEmail ? this.currentEmail : this.email
          );
      },
    },
  },
  beforeMount() {
    this.init();
  },
  mounted() {
    if (this.texts)
      this.newTexts = this.texts.replace(
        "{{email}}",
        this.currentEmail ? this.currentEmail : this.email
      );
  },
  computed: {
    ...mapState(["email", "fairConfig"]),
  },
  methods: {
    init() {
      this.answers = {};
      for (const field of this.questions) {
        if (field.type === "checkbox") {
          this.answers[field.pqt_id] = {};
          for (let checkbox of field.answers) {
            this.answers[field.pqt_id][checkbox.pqa_id] = false;
            // this.$set(this.answers[field.pqt_id], checkbox.pqa_id, false)
          }
        } else if (field.type === "badge") {
          this.answers[field.pqt_id] = {};
          for (let checkbox of field.answers) {
            this.answers[field.pqt_id][checkbox.pqa_id] = false;
            // this.$set(this.answers[field.pqt_id], checkbox.pqa_id, false)
            // console.log(Object.keys(this.answers[field.pqt_id]));
          }
        } else {
          this.answers[field.pqt_id] = "";
        }
      }
    },
    async resendEmail() {
      try {
        const res = await api.resendEmail({ email: this.email });
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    updateRadio(question, ans) {
      this.$set(this.answers, question.pqt_id, {
        pqa_id: ans.pqa_id,
        conditional: ans.conditional,
      });
    },
    handleNext() {
      // this checks if the registration fields have been filled
      if (this.required) {
        for (const field of this.questions) {
          if (field.type === "checkbox" || field.type === "badge") {
            let count = 0;
            for (let checkbox of field.answers) {
              if (this.answers[field.pqt_id][checkbox.pqa_id] == true) count++;
            }
            if (count === 0) {
              // if there is one tick for checkbox it usually is "I agree" or such so it must be ticked
              if (field.answers.length === 1)
                this.customError(this.$t("validate.mustAgree"));
              else this.customError(this.$t("validate.selectOneAnswer"));
              return;
            }
          } else {
            if (this.answers[field.pqt_id] === "") {
              this.customError(this.$t("validate.provideAllInfo"));
              return;
            }
          }
        }
      }
      this.$emit("next", this.answers);
    },
    handleAnswers(answers) {
      return answers.map((el) => {
        el.label = el.text;
        el.code = el.pqa_id;
        return el;
      });
    },
    handleCheckbox(val, questionId, answerId) {
      console.log(val, questionId, answerId);
      console.log(this.answers);
      this.answers[questionId][answerId] = val;
      // console.log(this.answers[questionId][answerId]);
    },
    handleBadge(e, qId, aId) {
      // console.log(e);
      this.$set(this.answers[qId], [aId], e);
      // console.log(this.answers[qId][aId]);
      this.$nextTick(() => {
        this.resetList = false;
      });
      this.$nextTick(() => {
        this.resetList = true;
      });
      // console.log(aId);
      // this.answers[qId][aId] = !this.answers[qId][aId];
    },
    handleSelectAnswer() {
      this.answers = Object.assign({}, this.answers);
    },
  },
};
</script>

<style scoped lang="scss">
.validate {
  overflow: hidden;
  width: 106%;
  min-height: 50vh;
  max-height: 70vh;
  height: 100%;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.7em;
  background: var(--main-color);
  .content-poll-wrap {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    overflow: auto;
    margin-top: 50px;
    height: calc(100% - 50px);
    .content {
      overflow: auto;
      padding: 0 20px 20px 20px;
      // width: 360px;
      // height: 100%;
      p {
        margin: 5px 0;
      }
      a {
        display: inline-block;
        margin: 10px 0;
      }
    }
  }
}

.center {
  text-align: center;
}
p {
  margin: 0;
}
.button-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
}
.button-round {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2295d6;
  border-radius: 2px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  &.is-last {
    background: #4bc076;
  }
  .material-icons {
    padding-left: 10px;
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.checkbox-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  padding: 3px;
  word-break: break-word;
  height: 60px;
  input {
    width: 30px;
    height: 30px;
  }
  label {
    padding-left: 10px;
    height: 30px;
    display: flex;
    align-items: center;
  }
}
.item {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 200px;
  // max-width: 300px;
  hr {
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.077);
    border: none;
    margin: 30px 0 15px;
  }
  .question-title {
    width: 100%;
    min-height: 30px;
    font-weight: 500;
    font-size: 16px;
    &:first-letter {
      text-transform: uppercase;
    }
  }
}
.badge-list {
  display: flex;
  flex-wrap: wrap;
}
.badge-wrap {
  margin: 5px 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: min-content;
}
.radio-inner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 5px 0;
  input[type="radio"] {
    width: 20px;
    height: 20px;
  }
  label {
    margin-left: 10px;
  }
}
.fixed-width {
  min-width: 15px;
  min-height: 15px;
  max-width: 15px;
  max-height: 15px;
}
.base-input[type="text"] {
  border-radius: 2px;
}
</style>

<style lang="scss">
div.custom-dropdown {
  border: none;
  border-radius: 2px;
  &.hack {
    width: 680px;
  }
  .vs__dropdown-toggle {
    border-radius: 2px;
  }
  .vs__open-indicator path {
    stroke: #fff;
  }
}
</style>
